import { RETRIEVE_MY_TASK, ACCEPT_NEW_TASK } from "../../actions/types";
const initialState = [];

function myTaskReducer(myTask = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case RETRIEVE_MY_TASK:
      return payload;

    case ACCEPT_NEW_TASK:
      return myTask.map((item) => {
        if (item.Task_id === payload.Task_id) {
          return {
            ...myTask,
            ...payload,
          };
        } else {
          return myTask;
        }
      });

    default:
      return myTask;
  }
}

export default myTaskReducer;
